var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panoramaView"},[_c('iframe',{staticClass:"content",attrs:{"src":_vm.link,"id":"qt","scrolling":"no","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }